import { type Auth0ContextInterface, useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

export type Auth0LoadResult = {
    error?: Error;
    isAuthenticated: boolean;
    loginWithRedirect: Auth0ContextInterface["loginWithRedirect"];
};

export type Auth0LoadPromise = Promise<Auth0LoadResult>;

type ResolveFn = (result: Auth0LoadResult) => void;

const useAuth0LoadPromise = (): Auth0LoadPromise => {
    const { isLoading, isAuthenticated, error, loginWithRedirect } = useAuth0();
    const [[promise, resolve]] = useState<[Promise<Auth0LoadResult>, ResolveFn]>(() => {
        let resolveFn: ResolveFn = () => null;

        const promise = new Promise<Auth0LoadResult>((resolve) => {
            resolveFn = resolve;
        });

        return [promise, resolveFn];
    });

    useEffect(() => {
        if (!isLoading) {
            resolve({ isAuthenticated, error, loginWithRedirect });
        }
    }, [isLoading, isAuthenticated, error, loginWithRedirect]);

    return promise;
};

export default useAuth0LoadPromise;
